import { apiRegistro } from '@/plugins/axios'

export default {
  getLogout() {
    return apiRegistro().get('/logout')
  },
}
